import { GET_TENANT_HISTORY } from "../../actions/actionTypes";

export const tenantHistoryReducer = (state={}, action) => {
    switch(action.type){
        case GET_TENANT_HISTORY:
            let currentProperty = {
                tenancyDetails: action.payload.tenantHistory.tenancyDetails,
                propertyContacts: action.payload.tenantHistory.propertyContacts,
                propertyDetails: action.payload.propertyDetails
            }
            return currentProperty;
        default:
            return state;
    }
}